import { Link } from "react-router-dom";
import { Film, Headphones, Users, Target, Moon, ListChecks, ArrowRight } from "lucide-react";

const ICON = { immersion: Film, installation: Headphones, practice: Users, missions: Target, audio: Moon, routine: ListChecks };
const EYEBROW = { immersion: "Immersion", installation: "Installation", practice: "Practice Room", missions: "Mission", audio: "Tonight's Audio", routine: "Routine" };

// Tap-to-open card under a coach message recommending something in Xcelio.
export default function CoachLinkCard({ card }) {
  const Icon = ICON[card.kind] || ArrowRight;
  return (
    <Link to={card.route} data-testid={`coach-card-${card.kind}-${card.id}`}
      className="mt-3 flex items-center gap-3 rounded-xl border border-primary/30 bg-primary/[0.06] px-3 py-2.5 hover:bg-primary/[0.12] transition-colors duration-200 not-italic">
      <span className="w-9 h-9 rounded-full bg-primary/15 text-primary flex items-center justify-center shrink-0"><Icon className="w-4 h-4" /></span>
      <span className="min-w-0 flex-1">
        <span className="block text-[10px] uppercase tracking-[0.2em] text-primary">{EYEBROW[card.kind] || "Open"}</span>
        <span className="block text-sm font-medium truncate">{card.title}</span>
        {card.sub && <span className="block text-xs text-muted-foreground truncate">{card.sub}</span>}
      </span>
      <ArrowRight className="w-4 h-4 text-primary shrink-0" />
    </Link>
  );
}
